import { authenticatedFetch } from "./utils";
import type { ApiResponse } from "../../types/api";
import API_CONSTANTS from "../constants/api";

export type LinkedInStartResponse = ApiResponse & { process_key: string };

export type LinkedInStartInput = {
  workflow_key: string;
  fingerprint: string;
  message: string;
};

export const linkedInStart = async (data: LinkedInStartInput): Promise<LinkedInStartResponse> => {
  const url = `${API_CONSTANTS.listenerBaseUrl}/v1/webhooks/linked-in?process_sync=true`;
  const result = await authenticatedFetch(url, {
    method: "POST",
    body: JSON.stringify(data)
  });

  return (await result.json()) as LinkedInStartResponse;
};

export type CallOfDutyStartResponse = ApiResponse & { process_key: string };
export type CallOfDutyStartInput = { workflow_key: string; };

export const callOfDutyStart = async (data: CallOfDutyStartInput): Promise<CallOfDutyStartResponse> => {
  const url = `${API_CONSTANTS.listenerBaseUrl}/v1/webhooks/callofduty?process_sync=true`;
  const result = await authenticatedFetch(url, {
    method: "POST",
    body: JSON.stringify(data)
  });

  return (await result.json()) as CallOfDutyStartResponse;
};
